import style from './exitLink.module.scss'


const ExitLink = ({ btnText, externalLink, setLink,linkStyle}) => (
        <>
            <button className={linkStyle} data-url={externalLink} onClick={setLink}>{btnText}</button>
        </>
    )

export default ExitLink;